export const BALLOON = 'BALLOON';
export const PLANE = 'PLANE';
export const JET = 'JET';
export const ROCKET = 'ROCKET';
export const WARP = 'WARP';
